import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, Category } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll } from 'services/WService.js';

//modal
import Modal from './Modal';
import PhotoModal from 'components/Tvendo/Common/PhotoModal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 160 },
  { Header: 'Código', accessor: 'code', width: 140 },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Foto', accessor: 'photo', excelEnabled: false, width: 80 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

/**
 * Categorías del mueble: qué ES cada mueble físico.
 *
 * No confundir con "Rango venta de mueble", que son los tramos de
 * venta del cliente.
 */
export default WithApp(function FurnitureCategory(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [modelFoto, setOpenFoto] = useModal();
  const [notify, showNotify] = useToasty();
  const [categories, setCategories] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadCategories() {
    setDataLoading(true);
    let response = await wsGetAll('base/furniture-category');
    setDataLoading(false);
    if (response.success) setCategories(response.data);
  }

  useEffect(() => {
    loadCategories();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={loadCategories} />
      ) : undefined}
      {modelFoto.open ? (
        <PhotoModal
          model={modelFoto}
          setOpen={setOpenFoto}
          showNotify={showNotify}
          reload={loadCategories}
          entity="base/furniture-category"
          texto="de la categoría"
          updatePermission={ConstantPermissions.BASE_FURNITURES_UPDATE}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_FURNITURES_STORE}
              component={
                <CardIcon color="primary">
                  <Category style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>
              Categorías de mueble {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Categorias de mueble"
              defaultWidth={700}
              columns={columns}
              data={categories.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.BASE_FURNITURES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColor}
                          onClick={() => setOpen(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_FURNITURES_DESTROY}>
                        <ButtonDelete
                          entity="base/furniture-category"
                          id={item.id}
                          reload={loadCategories}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  code: item.code,
                  description: item.description,
                  //la miniatura abre el modal en vez de la imagen suelta
                  photo: item.file_url ? (
                    <img
                      src={item.file_url}
                      alt=""
                      onClick={() => setOpenFoto(item)}
                      style={{
                        width: 38,
                        height: 38,
                        objectFit: 'cover',
                        borderRadius: 4,
                        cursor: 'pointer',
                      }}
                    />
                  ) : (
                    ''
                  ),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
